import type { ReactElement } from "react"
import { ColumnGrid } from "@/components/website-builder/ColumnGrid"
import { wrapWithBackgroundIfNeeded, type BlockComponentProps, HEADING_COLOR } from "./shared"

export function GalleryBlock({ content, resolved }: BlockComponentProps) {
  const gh = (content?.heading as string) ?? "Our work in action"
  const images = (content?.images as Array<{ url?: string; alt?: string; caption?: string }>) ?? []
  const galColumns = Math.min(3, Math.max(1, (content?.columns as number) ?? 3))
  const gallerySectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8"
  return wrapWithBackgroundIfNeeded(
    content,
    <section className={gallerySectionClass} style={resolved.sectionStyle}>
      <h2 className="text-2xl font-bold mb-6 text-center" style={{ color: HEADING_COLOR }}>
        {gh}
      </h2>
      <div className="max-w-4xl mx-auto">
        <ColumnGrid columns={galColumns} itemCount={images.length}>
          {images.map((img, i) =>
            img.url ? (
              <figure key={i} className="overflow-hidden rounded-lg">
                <img src={img.url} alt={img.alt ?? ""} className="w-full h-48 object-cover" />
                {img.caption && <figcaption className="mt-2 text-sm text-muted-foreground">{img.caption}</figcaption>}
              </figure>
            ) : (
              <div key={i} className="h-48 rounded-lg bg-muted flex items-center justify-center text-muted-foreground text-sm">
                Image {i + 1}
              </div>
            )
          )}
        </ColumnGrid>
      </div>
    </section>
  ) as ReactElement
}
